var map = {
	"./music-instructions.json": 4580,
	"./music-library-intro2024.json": 4581,
	"./music-library-launch2024.json": 4582,
	"./music-progression.json": 4583,
	"./startSourcesAdvanced.json": 4584,
	"./startSourcesSimple.json": 4585,
	"./startSourcesSimple2.json": 4586,
	"./startSourcesTracks.json": 4587
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4348;